import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"print"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M22.5005 8L1.50049 8L1.50049 17H6.00049L6.00049 15L18.0005 15V17L22.5005 17V8Z"}},{"tag":"g","attrs":{"id":"fill2"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M19.0005 3V8L5.00049 8L5.00049 3L19.0005 3Z"}},{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M18.0005 15V21L6.00049 21L6.00049 15H18.0005Z"}}]},{"tag":"g","attrs":{"id":"stroke2"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M19.0005 3V8L5.00049 8L5.00049 3L19.0005 3Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M18.0005 15V21L6.00049 21V15H18.0005Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]},{"tag":"g","attrs":{"id":"stroke1"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M18.0005 11.5H18.0044V11.4961H18.0005V11.5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M22.5005 8H1.50049V17H6.00049V15H18.0005V17H22.5005V8Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]}]};

const Print = Vue.extend<IconProps>({
  name: 'PrintIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'print',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Print;
